import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    orderResponse: null,
    checkoutData: null,
    orderPayload: null,
};

const paymentSlice = createSlice({
    name: "payment",
    initialState,
    reducers: {
        setPaymentData: (state, action) => {
            state.orderResponse = action.payload.orderResponse;
            state.checkoutData = action.payload.checkoutData;
            state.orderPayload = action.payload.orderPayload;
        },
        clearPayment: (state) => {
            state.orderResponse = null;
            state.checkoutData = null;
            state.orderPayload = null;
        },
    },
});

export const { setPaymentData, clearPayment } = paymentSlice.actions;
export default paymentSlice.reducer;
